// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--OiDcJ","container":"container--w1jlt","content":"content--wuUnh","fadeSlideUp":"fadeSlideUp--OGdzT"};